export const decodeEntities = (str: string) => {
  return str.replace(/&#([0-9]{1,4});/gi, (match, num: number) => {
    return String.fromCharCode(num);
  });
};
